import { Divider, Grid } from '@mui/material'
import { FormField, FormFieldCheckbox } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import { useFormContext } from 'react-hook-form'
import FormFaltasCadastradas from './FaltasCadastradas'
import HorasExtrasPart from './HorasExtras'
import FormHorista from './HoristaForm'
import PorcentagemPart from './Porcentagem'

export default function FormRegraCalculo() {
    const { watch } = useFormContext()

    const compensacaoManual = watch('compensacaoManual')
    const bancoHoras = watch('controlarBancoHoras')

    return (
        <Grid container spacing={2}>
            <Grid item sm={10} xs={9}>
                <FormField
                    name="nome"
                    label="Nome da regra de cálculo"
                    fullWidth
                />
            </Grid>
            <Grid item sm={2} xs={3}>
                <FormField
                    name="adicionalNoturno"
                    type="number"
                    label="Adicional noturno"
                    InputProps={{
                        endAdornment: <span>h</span>,
                    }}
                    min={0}
                    max={100}
                />
            </Grid>

            <Grid xs={12}>
                <Divider sx={{ mt: 3 }}>Compensações</Divider>
            </Grid>
            <Grid item sm={4} xs={6}>
                <div className="flex items-center w-full">
                    <FormFieldCheckbox
                        name="controlarBancoHoras"
                        label="Controla banco de horas"
                        disabled={compensacaoManual}
                    />{' '}
                    <IconeAjuda>
                        Caso habilitado, o saldo de horas do colaborador será
                        zerado apenas no fechamento do banco de horas.
                        <br />
                        <br />O período de fechamento do banco de horas é
                        configurado na tela de configurações da empresa.
                        <br />
                        <br />
                        <strong>Atenção:</strong> Esta opção não pode ser
                        habilitada junto com a compensação manual.
                    </IconeAjuda>
                </div>
            </Grid>
            <Grid item sm={4} xs={6}>
                <div className="flex items-center w-full">
                    <FormFieldCheckbox
                        name="compensacaoManual"
                        label="Compensação manual"
                        disabled={bancoHoras}
                    />{' '}
                    <IconeAjuda>
                        Caso habilitado, o sistema irá compensar manualmente as
                        horas do colaborador.
                        <br />
                        <br />
                        Se a sua empresa não faz o controle de compensações
                        manuais, mantenha a opção desabilitada.
                        <br />
                        <br />
                        <strong>Atenção:</strong> Esta opção não pode ser
                        habilitada junto com o controle de banco de horas.
                    </IconeAjuda>
                </div>
            </Grid>
            <Grid item sm={4} xs={6}>
                <div className="flex items-center w-full">
                    <FormFieldCheckbox
                        name="compensacaoDeHoras"
                        label="Compensação diária"
                    />{' '}
                    <IconeAjuda>
                        Caso habilitado, as faltas e horas extras que ocorrerem
                        no mesmo dia serão compensadas e o dia nunca vai
                        apresentar faltas e horas extras ao mesmo tempo.
                        <br />
                        <br />
                        Para controlar as compensações entre vários dias,
                        configure a porcentagem da regra de cálculo.
                    </IconeAjuda>
                </div>
            </Grid>
            <Grid item sm={4} xs={6}>
                <div className="flex items-center w-full">
                    <FormFieldCheckbox
                        name="compensarInjustificadas"
                        label="Compensar faltas injustificadas"
                    />
                    <IconeAjuda>
                        Caso desabilitado, o sistema não irá compensar faltas
                        injustificadas, utilize esta opção caso sua empresa faz
                        a separação entre faltas justificadas e injustificadas.
                    </IconeAjuda>
                </div>
            </Grid>
            <Grid item sm={4} xs={6}>
                <div className="flex items-center -gap-2 w-full">
                    <FormFieldCheckbox
                        name="compensarJustificadas"
                        label="Compensar faltas justificadas"
                    />
                    <IconeAjuda>
                        Caso desabilitado, o sistema não irá compensar faltas
                        justificadas, utilize esta opção caso sua empresa faz a
                        separação entre faltas justificadas e injustificadas.
                    </IconeAjuda>
                </div>
            </Grid>
            <Grid item sm={4} xs={6}>
                <div className="flex items-center w-full">
                    <FormFieldCheckbox
                        name="toleranciaCLT"
                        label="Tolerância CLT"
                    />
                    <IconeAjuda>
                        Caso habilitado, o sistema irá considerar a tolerância
                        conforme a CLT para os registros de ponto, independente
                        da configuração de tabela de horário.
                        <br />
                        <br />O parágrafo primeiro do art. 58 da CLT cita que:
                        “não serão descontadas nem computadas como jornada
                        extraordinária as variações de horário no registro de
                        ponto não excedentes de cinco minutos, observado o
                        limite máximo de dez minutos diários.”
                    </IconeAjuda>
                </div>
            </Grid>

            <Grid xs={12}>
                <Divider sx={{ my: 3 }}>Configurações das porcentagens</Divider>
            </Grid>
            <Grid item xs={12}>
                <PorcentagemPart />
            </Grid>

            <Grid xs={12}>
                <Divider sx={{ mt: 3 }}>
                    Configurações de horas extras semanais
                </Divider>
            </Grid>
            <Grid item xs={12}>
                <HorasExtrasPart />
            </Grid>

            <Grid xs={12}>
                <Divider sx={{ mt: 3 }}>Interjornada</Divider>
            </Grid>
            <Grid
                item
                sm={5}
                xs={6}
                height={95}
                className="flex items-center pb-4"
            >
                <FormFieldCheckbox
                    name="calcularHorasSuprimidas"
                    label="Calcular horas suprimidas"
                />
                <IconeAjuda>
                    Caso habilitado, o sistema irá calcular e exibir as horas
                    suprimidas no espelho de ponto e relatório de horas
                    suprimidas.
                    <br />
                    <br />
                    Quando desabilitado, o relatório de inconsistências ainda
                    vai exibir as horas suprimidas.
                </IconeAjuda>
            </Grid>
            <Grid item sm={2.5} xs={6}>
                <FormField
                    name="horasInterjornada"
                    label="Horas interjornada"
                    type="time"
                    InputProps={{
                        endAdornment: (
                            <div className="inline-flex items-center">
                                <span>h</span>
                                <IconeAjuda>
                                    Determina o intervalo mínimo entre a jornada
                                    de trabalho de um dia para outro. Horas
                                    inferiores a configuração serão consideradas
                                    como horas suprimidas.
                                    <br />
                                    <br />A CLT determina um intervalo mínimo de
                                    11 horas entre uma jornada e outra.
                                </IconeAjuda>
                            </div>
                        ),
                    }}
                    sx={{
                        '[type="time"]::-webkit-calendar-picker-indicator': {
                            display: 'none',
                        },
                    }}
                />
            </Grid>

            <Grid item xs={12}>
                <Divider sx={{ my: 3 }}>Configurações de horista</Divider>
            </Grid>
            <FormHorista />

            <Grid item xs={12}>
                <Divider sx={{ my: 3 }}>
                    Faltas justificadas/injustificadas
                </Divider>
            </Grid>
            <FormFaltasCadastradas />

            <Grid item xs={12} sx={{ mb: 2 }} />
        </Grid>
    )
}
